import React from "react";
import dayjs from "dayjs";
import { TextField } from "../material";
export { AdapterDayjs } from "./AdapterDayjs";

type AnyProps = Record<string, any>;
type DayjsValue = dayjs.Dayjs | null;

export const LocalizationProvider = ({ children }: AnyProps) => <>{children}</>;

export const DatePicker = ({
  value,
  onChange,
  label,
  disabled,
  slotProps,
  slots,
  name,
  id,
  ...props
}: AnyProps & {
  onChange?: (value: DayjsValue) => void;
  value?: DayjsValue;
}) => {
  const currentValue = value ? dayjs(value) : null;
  const valueString = currentValue && currentValue.isValid() ? currentValue.format("YYYY-MM-DD") : "";

  const fieldProps = {
    ...(slotProps?.textField ?? {}),
    id: id ?? slotProps?.textField?.id,
    name: name ?? slotProps?.textField?.name,
    label,
    type: "date",
    value: valueString,
    disabled,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
      const nextValue = event.target.value ? dayjs(event.target.value) : null;
      onChange?.(nextValue);
      slotProps?.textField?.onChange?.(event);
    },
  };

  const TextFieldComponent = slots?.textField ?? TextField;

  return <TextFieldComponent {...props} {...fieldProps} />;
};
